import type { ReactNode } from "react";

interface SectionCardProps {
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function SectionCard({ title, subtitle, action, children, className = "" }: SectionCardProps) {
  return (
    <section className={`rounded-[20px] bg-white p-6 shadow-card ${className}`}>
      {(title || action) && (
        <div className="flex items-start justify-between gap-4">
          <div>
            {title && <h2 className="text-base font-semibold text-ghasla-text-heading md:text-lg">{title}</h2>}
            {subtitle && <p className="mt-1 text-xs text-ghasla-text-secondary">{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      <div className={title ? "mt-5" : ""}>{children}</div>
    </section>
  );
}